import _ from "lodash";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getAssignUserReq,
  getBrokerageFilterListClear,
  getBrokerageFitlerList,
  getManagerReportReq,
  getManagerReportResClear,
  getTeamMatesReq,
  getTeamMatesResClear,
  setCurrentView,
} from "../../redux/assignCourse/actions";
import { setCurrentFilterView } from "../../redux/reports/actions";
import { SessionKeys } from "../../utils/AppUtils";
import StaticUtils from "../../utils/StaticUtils";
import Select from "react-select";
import CONFIG from "../../utils/config";
import API_LIST from "../../utils/apiList";

const ChooseBrokerage = (props) => {
  const {
    selectedBrokerageList,
    setSelectedBrokerageList,
    parentId,
    parentName,
    isMobile,
  } = props;

  const dispatch = useDispatch();
  const { courseId } = useParams();
  const brokerageFilterListRes = useSelector(
    (state) => state.assignCourse.brokerageFilterList
  );
  const [searchInput, setSearchInput] = useState("");
  const [brokerageList, setBrokerageList] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  const [assignedUsers, setAssignedUsers] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [brokerageOptList, setBrokerageOptList] = useState([]);
  const [defaultValue, setDefaultValue] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // dispatch(getBrokerageFilterListClear());
    setIsLoading(true);
    searchBrokerage();
    return () => {
      dispatch(getBrokerageFilterListClear());
    };
  }, [dispatch]);

  useEffect(() => {
    if (!_.isEmpty(brokerageOptList)) {
      setSelectedCount(selectedBrokerageList?.length);

      setDefaultValue(
        brokerageOptList.filter((b) => {
          if (selectedBrokerageList.includes(b.value)) {
            console.log("default value", b);
            return b;
          }
        })
      );
    }

    // const newDefaultValue = selectedBrokerageList.map((company) => ({
    //   value: company.company_id,
    //   label: company.company_name,
    //   }));
    //   setDefaultValue(newDefaultValue);
  }, [selectedBrokerageList, brokerageOptList]);

  // useEffect(() => {
  //   alert(JSON.stringify(defaultValue))
  // },[defaultValue])

  useEffect(() => {
    if (searchInput !== undefined && searchInput.length > 2) searchBrokerage();
    else setErrorMsg("");
  }, [searchInput]);

  const searchBrokerage = () => {
    dispatch(
      getBrokerageFitlerList({
        URL: `${CONFIG.API_URL_BROKER_ADMIN}/${API_LIST.BROKER_API.BROKERAGE_FILTER}`,
        payload: {
          token: isMobile
            ? localStorage.getItem(SessionKeys.API_TOKEN)
            : localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          search: searchInput,
        },
      })
    );
  };

  useEffect(() => {
    console.log("brokerageSearchres: ", brokerageFilterListRes);
    if (!_.isEmpty(brokerageFilterListRes)) {
      setErrorMsg("");
      if (brokerageFilterListRes?.status === "success") {
        const bList = brokerageFilterListRes?.payload?.data;
        setBrokerageList(bList);
        let defaultBrokerage = [
          {
            label: "Select Brokerage",
            value: "",
          },
        ];
        let brokerageArr = _.map(bList, (brokerage) => {
          return {
            value: brokerage.company_id,
            label: brokerage.company_name,
          };
        });
        setBrokerageOptList(defaultBrokerage.concat(brokerageArr));
      } else {
        setBrokerageList([]);
        setBrokerageOptList([]);
        if (!_.isEmpty(searchInput) && searchInput?.length > 2) {
          setErrorMsg("No result found for your search.");
        } else {
          setErrorMsg("");
        }
      }
      setIsLoading(false);
      dispatch(getBrokerageFilterListClear());
    }
  }, [brokerageFilterListRes]);

  const selectItem = (index) => {
    let tempArr = _.cloneDeep(brokerageList);
    let selectedTempArray = _.cloneDeep(selectedBrokerageList);
    if (!StaticUtils.isContainObject(selectedTempArray, tempArr[index], 1)) {
      selectedTempArray.push(tempArr[index]);
    }

    setSelectedBrokerageList(selectedTempArray);
    tempArr.splice(index, 1);
    setBrokerageList(tempArr);
  };

  const removeItem = (index) => {
    let selectedTempArray = _.cloneDeep(selectedBrokerageList);
    let tempArr = _.cloneDeep(brokerageList);

    if (!StaticUtils.isContainObject(tempArr, selectedTempArray[index], 1)) {
      tempArr.push(selectedTempArray[index]);
    }

    setBrokerageList(tempArr);
    selectedTempArray.splice(index, 1);
    setSelectedBrokerageList(selectedTempArray);
  };

  return (
    <>
      <div className="chooseteamate">
        <h4>Choose Brokerages</h4>
        <div className="input-lear position-relative d-flex">
          <label for="teamsearch" className="input__label_learning">
            Search
          </label>
          {/* <input
            type="text"
            id="teamsearch"
            name="teamsearch"
            className="input_searchfield_search-cart "
            placeholder="Start searching"
            onChange={(evt) => {
              setSearchInput(evt.target.value);
            }}
          /> */}
          <Select
            isMulti={false}
            name="colors"
            className="basic-multi-select w-100 multi-label-select"
            classNamePrefix="xsel"
            options={brokerageOptList}
            value={defaultValue}
            isLoading={isLoading}
            onChange={(e) => {
              console.log(e);
              // setSelectedOffice(e)
              if (!_.isEmpty(e)) {
                setErrorMsg("");
                let data = [];
                console.log("brokeragelist", brokerageList);
                for (let brokerage of brokerageList) {
                  // for (let sO of e) {
                  if (
                    _.toNumber(e.value) === _.toNumber(brokerage.company_id)
                  ) {
                    data.push(brokerage.company_id);
                  }
                  // }
                }
                setSelectedBrokerageList(data);
              } else {
                setSelectedBrokerageList([]);
                console.log("Please select at least one brokerage");
                // setErrorMsg("Please select at lease one manager.");
              }
            }}
          />
        </div>
        <p className="error-msg">{errorMsg}</p>
        {/* <div className="search-team-result">
          {brokerageList?.map((item, index) => {
            return (
              <div className="team-result-box">
                <div className="team-user-img">
                  <img
                    src={
                      item?.profile_img !== ""
                        ? item?.profile_img
                        : "/images/avatar.svg"
                    }
                    alt="user"
                  />
                </div>
                <div className="userteamname">{item?.user_name}</div>
                <div
                  className="addteammate cursor-pointer"
                  onClick={() => {
                    selectItem(index);
                  }}
                >
                  +
                </div>
              </div>
            );
          })}
        </div>
        <div className="teamselected">
          <div className="selectresilt">
            Selected Manager<strong>({selectedCount})</strong>
          </div>
          <div className="search-team-result slectedteammates">
            {selectedBrokerageList?.map((item, index) => {
              return (
                <div className="team-result-box">
                  <div className="team-user-img">
                    <img
                      src={
                        item?.profile_img !== ""
                          ? item?.profile_img
                          : "/images/avatar.svg"
                      }
                      alt="user"
                    />
                  </div>
                  <div className="userteamname">{item?.user_name}</div>
                  <div
                    className="addteammate cursor-pointer"
                    onClick={() => {
                      //   console.log("removeItem");
                      removeItem(index);
                    }}
                  >
                    +
                  </div>
                </div>
              );
            })}
          </div>
        </div> */}

        {false && (
          <div className="buttonsteammate">
            {false && (
              <button
                type="button"
                className="btn btn-primary btn-block back-button"
                onClick={() => {
                  dispatch(setCurrentFilterView(1));
                }}
              >
                Back
              </button>
            )}

            <button
              type="button"
              className="btn btn-primary btn-block setup-button"
              onClick={() => {
                setSelectedBrokerageList(selectedBrokerageList);
                // dispatch(setCurrentFilterView(1));
              }}
            >
              Apply
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default ChooseBrokerage;
